"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = require("../model/model");
const model_algorithm_1 = require("../model/model-algorithm");
const cox_survival_algoritm_1 = require("./cox-survival-algoritm");
// Contains methods to create new Model objects
class ModelFactory {
    /**
     * Used to extend a model object at runtime for eg. to add new methods and
     * properties to it
     *
     * @static
     * @template U
     * @param {Model} model The Model object to extend
     * @param {U[]} newCoxProperties properties that will be added to the
     * algorithms within the model. Each entry in the array will be used to
     * extend the algorithm at the same entry in the model
     * @returns {(Model<U & CoxSurvivalAlgorithm>)}
     * @memberof ModelFactory
     */
    static extendModel(model, newModelProperties, newCoxProperties) {
        const modelAlgorithms = model.algorithms.map((modelAlgorithm, index) => {
            if (newCoxProperties) {
                return Object.setPrototypeOf(Object.assign({}, modelAlgorithm, {
                    algorithm: cox_survival_algoritm_1.CoxFactory.extendCox(modelAlgorithm.algorithm, newCoxProperties[index]),
                }), model_algorithm_1.ModelAlgorithm.prototype);
            }
            else {
                return modelAlgorithm;
            }
        });
        return Object.setPrototypeOf(Object.assign({}, model, newModelProperties, {
            algorithms: modelAlgorithms,
        }), model_1.Model.prototype);
    }
}
exports.ModelFactory = ModelFactory;
//# sourceMappingURL=model-factory.js.map